<template>
    <div class="main-box mh-a">
        <!-- 新闻详情 -->
        <iristar-dividing> {{ $t("title.title6") }} </iristar-dividing>
        <el-card class="box-card">
            <h3 class="fs24 text-center" style="white-space:pre-line">{{ newsDetial.title }}</h3>
            <p class="fs14 text-center lh80">{{ newsDetial.time }}</p>
            <div
                v-for="(item, index) in newsDetial.content"
                :key="`${index}_news`"
                class="m-news-text"
            >
                <p
                    v-if="item.type === 'text'"
                    class="text-indent lh30 fs14 c-g-d ph80"
                    :class="item.align ? `text-${item.align}` : `text-left`" v-html="item.inner"
                >
                   
                </p>
                <div v-if="item.type === 'img'" class="text-center mv40">
                    <img class="min-img" :src="item.inner" :alt="item.desc">
                    <p>{{ item.desc }}</p>
                </div>
               
            </div>

        </el-card>
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import NewsList from "@/assets/news/newsList";
import NewsListEn from "@/assets/news/newsList-en";
export default {
    name: "NewsDetails",
    computed: {
        newsDetial() {
            let list =
                this.$store.state.language === "zh" ? NewsList : NewsListEn;
            let detialArr = list.filter((item) => {
                return item.id == this.$route.params.index;
            });

            return detialArr[0];
        },
    },
    components: {
        IristarDividing,
    },
};
</script>

<style lang="less">
</style>